import { createTweenAndPromise } from '../components/Animation';
import * as createjs from 'createjs-module';
import { renderTree, updateValueFromDisplayObject } from '../graphics/cjs-lib';

export let actions = {
  ADD_CANVAS: addCanvas,
  ADD_STAGE: addStage,
  ADD_DISPLAY_OBJECT: addDisplayObject,
  ADD_DISPLAY_OBJECTS: addDisplayObjects,
  REMOVE_DISPLAY_OBJECT: removeDisplayObject,
  ADD_TWEENITEM: addTweenItem,
  REMOVE_TWEENITEM: removeTweenItem,
  START_TWEEN: startTween,
  ADD_HANDLER: addHandler,
  WAIT: wait
};

export function addItem(item) {
  return {
    type: 'ADD_ITEM',
    payload: {
      item
    }
  };
}

export function updateItem(id, attributes) {
  return {
    type: 'UPDATE_ITEM',
    payload: {
      id,
      attributes
    }
  };
}

export function updateItems(items) {
  return {
    type: 'UPDATE_ITEMS',
    payload: {
      items
    }
  };
}

export function addCanvas({ canvas, actionId }) {
  return {
    type: 'ADD_CANVAS',
    payload: {
      canvas,
      actionId
    }
  };
}

export function addStage({ stage, actionId }) {
  return {
    type: 'ADD_STAGE',
    payload: {
      stage,
      actionId
    }
  };
}

export function addDisplayObject({parentId, id, type, value, actionId}) {
  return {
    type: 'ADD_DISPLAY_OBJECT',
    payload: {
      parentId,
      id,
      type,
      value,
      actionId
    }
  };
}

export function addDisplayObjects({actionId, items = []}) {
  return {
    type: 'ADD_DISPLAY_OBJECTS',
    payload: {
      actionId,
      items
    }
  };
}

export function removeDisplayObject({ id, actionId }) {
  return {
    type: 'REMOVE_DISPLAY_OBJECT',
    payload: {
      id,
      actionId
    }
  };
}

export function addTweenItem({ tweenItem, actionId }) {
  return {
    type: 'ADD_TWEENITEM',
    payload: {
      tweenItem,
      actionId
    }
  };
}

export function removeTweenItem({ removedTweenItem, actionId }){
  return {
    type: 'REMOVE_TWEENITEM',
    payload: {
      removedTweenItem,
      actionId
    }
  };
}

export function startTween({ tweenItem, startActionId, actionId }) {
  return function (dispatch, getState) {
    let state = getState();
    const { stage, canvas, handlers } = state;
    let { tree } = state;
    console.log('.before tree', tree);
    stage.update();
    console.log('startTween', state);
    console.log((new Date()).toLocaleTimeString());
    if (tree) {
      // const newTree = state.tree.clone();
      // renderTree({ tree: newTree, canvas, stage, handlers });
      // const { tween, promise } = createTweenAndPromise({ tree: newTree, id, commands});
      // renderTree({ tree, canvas, stage, handlers });
      const { tween, promise } = createTweenAndPromise({ tree, id: tweenItem.id, commands: tweenItem.commands});
      if (tween) {
        const timeline = new createjs.Timeline();
        timeline.addTween(tween);
        tweenItem.startTime = Date.now();
        tweenItem.timeline = timeline;
        console.log('starting tween actionId:', startActionId);
        dispatch(addTweenItem({ tweenItem, actionId: startActionId }));
        timeline.gotoAndPlay(0);
        promise
          .then(() => {
            stage.update();
            state = getState();
            const { tree, tweenItems, actionMap } = state;
            // tree = state.tree;
            console.log('.then tree', tree);
            console.log((new Date()).toLocaleTimeString());
            console.log('tweenItems', tweenItems);
            tweenItems.forEach(item => {
              updateValueFromDisplayObject({ tree, id: item.id });
            });
            /*
             * TODO: remove executed tweenItem from tweenItems
             */
            const tweenIndex = tweenItems.indexOf(tweenItem);
            if (tweenIndex >= 0) {
              tweenItems.splice(tweenIndex, 1);
            }
            const newTree = tree.clone({ tweenItems });
            renderTree({ tree: newTree, canvas, stage, handlers, tweenItems });
            console.log('ending tween actionId:', actionId);
            const newActionMap = actionMap.clone();
            newActionMap.updateCompletedStatus({ actionId, status: true });
            dispatch(setActionMap({ actionMap: newActionMap }));
            dispatch(updateTree({updatedTree: newTree, actionId }));
            stage.update();
            // dispatch(sendActionId({ actionId }));
          });
      }
    }
  };
}

export function runTween({ id, commands, actionId }) {
  return function (dispatch, getState) {
    let state = getState();
    const { canvas, stage, handlers, tweenItems } = state;
    let { tree } = state;
    stage.update();
    console.log('runTween', state);
    if (tree) {
      // const newTree = state.tree.clone();
      // renderTree({ tree: newTree, canvas, stage, handlers });
      // const { tween, promise } = createTweenAndPromise({ tree: newTree, id, commands});
      // renderTree({ tree, canvas, stage, handlers });
      const { tween, promise } = createTweenAndPromise({ tree, id, commands});
      if (tween) {
        const timeline = new createjs.Timeline();
        timeline.addTween(tween);
        timeline.gotoAndPlay(0);
        promise
          .then(() => {
            state = getState();
            let { tree } = state;
            console.log('.then tree', tree);
            stage.update();
            updateValueFromDisplayObject({ tree, id });
            const newTree = tree.clone({ tweenItems });
            renderTree({ tree: newTree, canvas, stage, handlers });
            dispatch(updateTree({updatedTree: newTree, actionId }));
            stage.update();
            // dispatch(sendActionId({ actionId }));
          });
      }
    }
  };
}

export function removeActionId({ actionId }) {
  return {
    type: 'REMOVE_ACTIONID',
    payload: {
      removedActionId: actionId
    }
  };
}

export function sendActionId({ actionId }) {
  return {
    type: 'SEND_ACTIONID',
    payload: {
      actionId
    }
  };
}

export function setActionMap({ actionMap }) {
  return {
    type: 'SET_ACTIONMAP',
    payload: {
      newActionMap: actionMap
    }
  };
}

export function addHandler({ id, actionId, handler }) {
  return {
    type: 'ADD_HANDLER',
    payload: {
      id,
      actionId,
      handler
    }
  };
}

export function wait({ actionId, delay }) {
  return function (dispatch) {
    delay = Math.max(delay, 0);
    setTimeout(() => {
      dispatch(sendActionId({ actionId }));
    }, delay);
  };
}

/*
export function executeTween({ id, commands }) {
  return function (dispatch, getState ) {
    const state = getState();
    console.log('executeTween', state);
    if (state && state.tree) {
      const newTree = state.tree.clone();
      console.log('newTree', newTree);
      dispatch(addTween({ id, commands, dispatch }));
      const totalTime = commands.reduce((acc, next) => {
        acc += next.dt;
        return acc;
      }, 0) + 10;
      const node = newTree.get(id);
      const value = commands.reduce((acc, next) => {
        if (typeof next.value === 'object') {
          Object.keys(next.value).forEach(key => {
            if (['x', 'y', 'width', 'height'].includes(key)) {
              if (acc.bounds) {
                acc.bounds[key] = next.value[key];
              }
            } else {
              acc[key] = value[key];
            }
          });
        }
        return acc;
      }, node.value);
      newTree.updateValue({ id, value });
      console.log('newTree', newTree);
      const p = new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, totalTime);
      })
      p.then(() => {
        dispatch(updateTree({updatedTree: newTree}));
      });
    }
  };
}
*/

export function updateTree({ updatedTree, actionId }) {
  return {
    type: 'UPDATE_TREE',
    payload: {
      updatedTree,
      actionId
    }
  };
}

// import Rectangle from '../graphics/Rectangle';

/*
export function incrementAngle({ delta }) {
  return {
    type: 'INCREMENT_ANGLE',
    payload: {
      angle_increment: delta
    }
  };
}
*/

/*
export function addRectangle(attributes) {
  const item = new Rectangle(attributes)
  return {
    type: 'ADD_RECTANGLE',
    payload: {
      item
    }
  };
}
*/


